/* GAIA Portal Profesional · JS compartit
   - Add to cart via AJAX (/cart/add.js) + toast + comptador
   - Steppers de quantitat
*/
(function () {
  'use strict';

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'pp-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2400);
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-pp-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        });
      })
      .catch(function () {});
  }

  // ---- Steppers de quantitat ----
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-pp-minus]');
    var plus = e.target.closest('[data-pp-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.pp-qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  // ---- Add to cart (formularis amb data-pp-atc) ----
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-pp-atc]');
    if (!form) return;
    e.preventDefault();
    // Kits con elección obligatoria (color…): no se añade sin elegir
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Error'); });
        return r.json();
      })
      .then(function () {
        toast(form.getAttribute('data-pp-atc-msg') || 'Producto añadido al carrito');
        updateCartCount();
      })
      .catch(function (err) {
        toast(err.message || 'No se pudo añadir el producto');
      })
      .finally(function () {
        if (btn && !btn.classList.contains('is-soldout')) btn.disabled = false;
      });
  });

  // ---- Selector de variant: actualitza preus de la targeta ----
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-pp-variant]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('.pp-product-card');
    if (!card || !opt) return;
    var pro = card.querySelector('.pp-price-pro');
    var pvp = card.querySelector('[data-pp-pvp-label]');
    if (pro && opt.dataset.pro) pro.textContent = opt.dataset.pro;
    if (pvp && opt.dataset.pvp) pvp.textContent = opt.dataset.pvp;
    var save = card.querySelector('[data-pp-save]');
    if (save) {
      var savePct = parseInt(opt.dataset.savePct || '0', 10);
      var nivelPct = parseInt(card.dataset.nivelPct || '0', 10);
      if (savePct > nivelPct) {
        save.hidden = false;
        save.textContent = (save.dataset.tpl || 'Ahorro total −[pct]% vs PVP').replace('[pct]', savePct);
      } else {
        save.hidden = true;
      }
    }
    var idInput = card.querySelector('input[name="id"]');
    if (idInput) idInput.value = opt.value;
    var addBtn = card.querySelector('.pp-btn-add');
    if (addBtn) {
      var avail = opt.dataset.available === 'true';
      addBtn.disabled = !avail;
      addBtn.classList.toggle('is-soldout', !avail);
      addBtn.textContent = avail ? (addBtn.dataset.label || '+ Añadir') : (addBtn.dataset.soldout || 'Agotado');
    }
  });

  // ---- Filtres de la tienda ----
  function applyTiendaFilter(section, chip) {
    section.querySelectorAll('[data-pp-filter]').forEach(function (b) { b.classList.remove('is-active'); });
    chip.classList.add('is-active');
    var key = chip.getAttribute('data-pp-filter');
    section.querySelectorAll('[data-pp-group]').forEach(function (g) {
      g.style.display = (key === 'todos' || g.getAttribute('data-pp-group') === key) ? '' : 'none';
    });
  }
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-pp-filter]');
    if (!chip) return;
    var section = chip.closest('[data-pp-tienda]');
    if (!section) return;
    applyTiendaFilter(section, chip);
  });
  // Enllaç directe a una categoria: /pages/portal-tienda?cat=<handle col·lecció>
  // (o ?cat=todos). El fan servir les targetes de categoria de l'Inicio.
  function initTiendaDeepLink() {
    var cat = null;
    try { cat = new URLSearchParams(window.location.search).get('cat'); } catch (e) {}
    if (!cat) return;
    document.querySelectorAll('[data-pp-tienda]').forEach(function (section) {
      var chips = section.querySelectorAll('[data-pp-filter]');
      for (var i = 0; i < chips.length; i++) {
        if (chips[i].getAttribute('data-pp-cat') === cat || chips[i].getAttribute('data-pp-filter') === cat) {
          applyTiendaFilter(section, chips[i]);
          break;
        }
      }
    });
  }

  // ---- Mi cuenta: repetir último pedido ----
  // Añade una a una las líneas del último pedido (variante + cantidad +
  // propiedades visibles, p. ej. el color de un kit). Salta las variantes
  // no disponibles y avisa de las que no se han podido añadir.
  function addLine(item) {
    var props = {};
    Object.keys(item.properties || {}).forEach(function (k) {
      if (k.charAt(0) !== '_' && item.properties[k] !== '') props[k] = item.properties[k];
    });
    var body = { id: item.id, quantity: item.quantity };
    if (Object.keys(props).length) body.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-reorder]');
    if (!btn) return;
    var card = btn.closest('[data-pp-orders-card]');
    var dataEl = card && card.querySelector('[data-pp-reorder-data]');
    var msg = card && card.querySelector('[data-pp-reorder-msg]');
    if (!dataEl) return;
    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var cartUrl = btn.getAttribute('data-cart-url') || '/cart';
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-label-busy') || original;
    var failed = [];
    var added = 0;
    var chain = Promise.resolve();
    items.forEach(function (item) {
      chain = chain.then(function () {
        if (!item.id || item.available !== true) { failed.push(item.title); return; }
        return addLine(item).then(function (ok) { if (ok) { added++; } else { failed.push(item.title); } });
      });
    });
    chain.then(function () {
      updateCartCount();
      if (added > 0 && failed.length === 0) { window.location.href = cartUrl; return; }
      btn.disabled = false;
      btn.textContent = original;
      if (!msg) { if (added > 0) window.location.href = cartUrl; return; }
      msg.hidden = false;
      msg.textContent = '';
      var p = document.createElement('span');
      if (added > 0) {
        p.textContent = (btn.getAttribute('data-msg-partial') || '[productos]').replace('[productos]', failed.join(', '));
        msg.appendChild(p);
        var a = document.createElement('a');
        a.href = cartUrl;
        a.className = 'pp-account-action pp-account-action--primary';
        a.textContent = btn.getAttribute('data-label-cart') || 'Ir al carrito';
        msg.appendChild(a);
      } else {
        p.textContent = btn.getAttribute('data-msg-none') || '';
        msg.appendChild(p);
      }
    });
  });

  function ppInit() { updateCartCount(); initTiendaDeepLink(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ppInit);
  } else {
    ppInit();
  }
})();
